import { CommonResourceKey } from '@shared/models/ResourceKeys';
import { IControlDescription } from '@shared/models/profiles/ControlDescription';

export const TiltControlsTiltLeft = 'tiltleft';
export const TiltControlsTiltRight = 'tiltright';
export const TiltControlsTiltDown = 'tiltdown';
export const TiltControlsTiltUp = 'tiltup';
export const TiltControlsShake = 'shake';
export const TiltControls = [
    TiltControlsShake,
    TiltControlsTiltUp,
    TiltControlsTiltDown,
    TiltControlsTiltRight,
    TiltControlsTiltLeft,
];

export const IsTiltControl = (command: string) => TiltControls.indexOf(command) > -1;

const createTiltCommand = (
    value: string,
    title: CommonResourceKey,
    description: CommonResourceKey
): IControlDescription => {
    return {
        value,
        title,
        description,
    };
};

export const TiltControlDescription = [
    createTiltCommand(TiltControlsTiltUp, 'common:motion.up.title', 'common:motion.up.description'),
    createTiltCommand(TiltControlsTiltDown, 'common:motion.down.title', 'common:motion.down.description'),
    createTiltCommand(TiltControlsTiltLeft, 'common:motion.left.title', 'common:motion.left.description'),
    createTiltCommand(TiltControlsTiltRight, 'common:motion.right.title', 'common:motion.right.description'),
    createTiltCommand(TiltControlsShake, 'common:motion.shake.title', 'common:motion.shake.description'),
];
